import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import checkAccessBasedOnAssignmentPermissions from './checkAccessBasedOnAssignmentPermissions.helper';

const checkAssignmentPermissions = createSelector(
  ({ user }) => user.user,
  ({ withAssignments }) => withAssignments,
  ({ shared }) => shared.companyCode,
  (user, withAssignments, companyCode) => checkAccessBasedOnAssignmentPermissions({
    user, withAssignments, companyCode,
  })
);


const withAssignmentsPermissions = WrappedComponent => (
  class WithAssignmentPermissionsWrapper extends PureComponent {
    render() {
      return (
        <WrappedComponent
          {...this.props}
        />
      );
    }
  }
);

export default withAssignments => compose(
  connect(state => ({
    hasAccessBasedOnAssignments: checkAssignmentPermissions({
      ...state,
      withAssignments,
    }),
  })),
  withAssignmentsPermissions
);
